import Vue from 'vue'

import 'normalize.css/normalize.css' // A modern alternative to CSS resets

import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import locale from 'element-ui/lib/locale/lang/zh-CN' // lang i18n
import VCharts from 'v-charts'

import '@/styles/index.scss' // global css

import App from './App'
import router from './router'
import store from './store'

import '@/icons' // icon
import '@/permission' // permission control

import BaiduMap from 'vue-baidu-map-v3'

Vue.use(BaiduMap, {
    ak: 'TeN56PtSyHSywQfWudeG0dGVvba9x1eF'
})

// 引入高德地图
import VueAMap from 'vue-amap';

Vue.use(VueAMap);


// 初始化vue-amap
VueAMap.initAMapApiLoader({
    // 高德的key
    key: '9796cac74abdbb3c55a6b1fac6e1b74e',
    // 插件集合
    plugin: ['AMap.Autocomplete', 'AMap.PlaceSearch', 'AMap.Scale', 'AMap.OverView', 'AMap.ToolBar', 'AMap.MapType', 'AMap.PolyEditor', 'AMap.CircleEditor'],
    // 高德 sdk 版本，默认为 1.4.4
    v: '1.4.4',
    uiVersion: '1.0.11' // ui版本号，也是需要写，不配置不加载,
});


Vue.use(ElementUI, { locale })
Vue.use(VCharts)

Vue.config.productionTip = false

new Vue({
    el: '#app',
    router,
    store,
    template: '<App/>',
    components: { App }
})


// WEBPACK FOOTER //
// ./src/main.js